module.exports = __webpack_public_path__ + "media/images/caregiver/caregiver_avatar_06-6542ac1f167e0b9452b71b90b5870642.png";